module.exports = __webpack_public_path__ + "img/pasted image 1.51a06ac4.png";